import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abaeb5ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "user-header" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Activation staus ", -1))
const _hoisted_5 = { class: "col-sm-4" }
const _hoisted_6 = {
  key: 0,
  class: "status-enabled chip"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "status-disabled chip"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus-circle" }, null, -1))
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Copy activation button for email", -1))
const _hoisted_12 = { class: "col-sm-4" }

import { computed, inject } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'Depository',
  setup(__props) {

const store = useStore();
const actProperty: any = inject('actProperty');

const customer = computed(() => store.getters['customers/current']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (customer.value.depository && customer.value.depository.authToken)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" Active ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode(" Not active ")
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-success",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(actProperty).copyDepositoryActivationButton(customer.value.id)))
            }, " Activate ACT ")
          ])
        ])
      ])
    ])
  ]))
}
}

})